var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noshow",
    d: "M17.0697 10.1666V10.1621M15.2793 5.03332C15.5183 4.28952 16.2295 3.74999 17.0696 3.74999C18.1059 3.74999 18.9459 4.5708 18.9459 5.58332C18.9459 7.05617 17.3715 6.33203 17.1126 7.87498M5.19595 12H12.5293C14.5543 12 16.1959 13.6416 16.1959 15.6666V17.4999H1.5293V15.6666C1.5293 13.6416 3.17091 12 5.19595 12ZM12.5293 4.66665C12.5293 6.69169 10.8876 8.33331 8.86261 8.33331C6.83757 8.33331 5.19595 6.69169 5.19595 4.66665C5.19595 2.64162 6.83757 1 8.86261 1C10.8876 1 12.5293 2.64162 12.5293 4.66665Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShowIcon);
export default __webpack_public_path__ + "static/media/NoShow_icon.647ad54ef6fa16c07797dfa936b07991.svg";
export { ForwardRef as ReactComponent };